<template>
  <div id="verifyPhonePage">
    <form v-if="showUpdatePhoneSuccessMessage" novalidate>
      <p class="has-text-centered is-size-7 disclaimer">Please enter the One Time Pin we sent to your mobile</p>
      <p class="control">
        <input v-model.trim="otp_form.otp" :disabled="sending" class="input hp-input" name="otp"
               placeholder="One Time Pin"
               type="text"/>
      </p>
      <p v-if="otp_form.errors.has('otp')" class="help is-danger" v-html="otp_form.errors.get('otp')"></p>
      <p class="control">
        <button
          id="otp_button"
          :class="[{ 'is-loading': sending}, 'button', 'hp-btn-primary', 'is-fullwidth']"
          :disabled="!canSubmitOtp || sending"
          type="submit"
          @click.prevent="submitOTP">VERIFY OTP
        </button>
      </p>
      <p class="control">
        <button
          id="re_enter_mobile"
          :class="['button', 'hp-btn-primary', 'is-fullwidth']"
          :disabled="sending"
          @click.prevent="reEnterMobile">CHANGE MOBILE NUMBER
        </button>
      </p>
      <div v-html="OTP_MESSAGES.CHECK_SPAM.HTML"></div>
      <!-- reCAPTCHA -->
      <div class="columns">
        <div class="column is-marginless captchaBox">
          <div class="has-text-right-desktop has-text-right-tablet">
            <vue-recaptcha
              ref="recaptcha_otp"
              :sitekey="`${google_recaptcha_site_key}`"
              size="invisible"
              @expired="onCaptchaExpiredOtp"
              @verify="onCaptchaVerifiedOtp">
            </vue-recaptcha>
          </div>
        </div>
      </div>
    </form>
    <!-- <p v-if="showUpdatePhoneSuccessMessage" class="register-success-message-box" v-html="registerSuccessMessage"></p> -->
    <form v-else novalidate>
      <flash-message size="is-size-7"></flash-message>
      <template v-if="canShowEnterMobileScreen">
        <div v-if="smsFailed" v-html="smsFailed"></div>
        <p class="has-text-centered is-size-7 disclaimer">Please enter your mobile to verify your profile</p>
        <p class="control">
          <vue-phone :phone.sync="form.mobile" :disabled="sending"/>
        </p>
        <p v-if="form.errors.has('mobile')" class="help is-danger" v-html="form.errors.get('mobile')"></p>
        <!-- links for general terms and privacy policy -->
        <p class="control">
          <button
            id="loginButton"
            :class="[{ 'is-loading': sending}, 'button', 'hp-btn-primary', 'is-fullwidth']"
            :disabled="!canSubmit"
            type="submit"
            @click.prevent="submitRegister">VERIFY MOBILE
          </button>
        </p>
      </template>

      <!-- SEND CODE TO EMAIL SCREEN -->
      <p v-if="canShowSendCodeScreen" class="control has-text-left is-size-7">The mobile number you entered is associated with another profile using email address <b>{{ form.errors.get('conflict') }}</b>. Does this email belong to you?</p>
      <p v-if="canShowSendCodeScreen" class="control has-text-left is-size-7">If yes, please confirm the email below to receive a unique code</p>
      <template v-if="canShowSendCodeScreen">
        <p class="control">
          <input v-model.trim="confirm_email" :disabled="sending" class="input hp-input" name="confirm_email"
                 placeholder="Confirm email"
                 type="text"/>
        </p>
        <p v-if="confirm_email_error" class="help is-danger" v-html="confirm_email_error"></p>
      </template>
      <p v-if="canShowSendCodeScreen" class="control">
        <button
          id="sendCodeButton"
          :class="[{ 'is-loading': sending}, 'button', 'hp-btn-primary', 'is-fullwidth']"
          :disabled="sending || !isValidEmail"
          @click.prevent="sendCode">SEND CODE
        </button>
      </p>

      <!-- VERIDY CODE SCREEN -->
      <p v-if="canShowCodeVerifyScreen" class="control has-text-left is-size-7">Please enter the <b>code</b> sent to your email address <b>{{ confirm_email }}</b></p>
      <template v-if="canShowCodeVerifyScreen">
        <p class="control">
          <input v-model.trim="verify_code" :disabled="sending" class="input hp-input" name="verify_code"
                 placeholder="Verify CODE"
                 type="text"/>
        </p>
        <p v-if="verify_code_error" class="help is-danger" v-html="verify_code_error"></p>
      </template>
      <p v-if="canShowCodeVerifyScreen" class="control">
        <button
          id="sendCodeButton"
          :class="[{ 'is-loading': sending}, 'button', 'hp-btn-primary', 'is-fullwidth']"
          :disabled="sending || !isValidCode"
          @click.prevent="verifyCode">VERIFY CODE
        </button>
      </p>

      <p v-if="canShowSendCodeScreen && !canShowCodeVerifyScreen" class="control has-text-left is-size-7 mt-10">If you've captured the number incorrectly, you can press the <b>CHANGE&nbsp;MOBILE&nbsp;NUMBER</b> below</p>
      <p v-if="canShowSendCodeScreen && !canShowCodeVerifyScreen" class="control">
        <button
          id="changeMobileNumberButton"
          :class="[{ 'is-loading': sending}, 'button', 'hp-btn-primary', 'is-fullwidth']"
          :disabled="sending"
          @click.prevent="reEnterMobile">CHANGE MOBILE NUMBER
        </button>
      </p>

      <p v-if="smsFailedEmail" class="control has-text-centered has-text-weight-bold is-size-7 lh mt-5">
        Having trouble verifying your account?<br/>
        {{ smsFailedEmail }}
      </p>
      <!-- reCAPTCHA -->
      <div class="columns">
        <div class="column is-marginless captchaBox">
          <div class="has-text-right-desktop has-text-right-tablet">
            <vue-recaptcha
              ref="recaptcha"
              :sitekey="`${google_recaptcha_site_key}`"
              size="invisible"
              @expired="onCaptchaExpired"
              @verify="onCaptchaVerified">
            </vue-recaptcha>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
/* eslint-disable indent,no-new,no-undef */
import axios from 'axios'
import ApiResource from '@/api/ApiResource'
import FlashMessage from '@/components/FlashMessage'
import VueRecaptcha from 'vue-recaptcha'
import {VuePhone} from '@/components'
import {otp_phone_verification} from '@/mixins'

export default {
  name: 'VerifyPhone',
  props: {
    token: {
      type: String,
      default: ''
    }
  },
  mixins: [otp_phone_verification],
  components: {
    FlashMessage,
    VueRecaptcha,
    VuePhone
  },
  metaInfo: {
    title: 'Hellopeter | Verify Phone'
  },
  mounted () {
    this.$gtm.trackEvent({
      event: 'pageLoad',
      virtualPageUrl: this.$router.currentRoute.path,
      virtualPageTitle: 'Verify Phone'
    })
    window.prerenderReady = true
  },
  created () {
    this.verifyToken().then(() => {
      if ('traceCode' in this.$route.query && this.$route.query.traceCode) {
        this.populateSmsFailedErr(this.$route.query.traceCode)
      }
    })
  },
  data () {
    return {
      mountedUserToken: '',
      isCodeSendForm: false,
      isCodeVerifyForm: false,
      verify_code: '',
      verify_code_error: '',
      confirm_email: '',
      confirm_email_error: '',
      disableStrength: true,
      sending: false,
      form: new ApiResource({
        token: this.token,
        mobile: '',
        recaptchaToken: ''
      }),
      otp_form: new ApiResource({
        token: this.token,
        otp: '',
        recaptchaToken: ''
      }),
      error: false,
      socialError: false,
      error_message: '',
      registerSuccessMessage: '',
      showUpdatePhoneSuccessMessage: false,
      require_email: false,
      social: false,
      google_recaptcha_site_key: process.env.GOOGLE_RECAPCHA_SITE_KEY
    }
  },
  computed: {
    canSubmitOtp () {
      const otp = this.otp_form.otp
      return otp.length > 0 && otp.match(/^(\d\s*){6}$/g)
    },
    canSubmit () {
      const mobile = this.form.mobile
      return typeof mobile !== 'undefined' && mobile.length > 0
    },
    canShowEnterMobileScreen () {
      if (this.form.errors.has('conflict')) {
        return false
      }
      return !(this.isCodeSendForm || this.isCodeVerifyForm)
    },
    canShowSendCodeScreen () {
      return this.form.errors.has('conflict') || this.isCodeSendForm && !this.isCodeVerifyForm
    },
    canShowCodeVerifyScreen () {
      return !this.isCodeSendForm && this.isCodeVerifyForm
    },
    isValidEmail () {
      const email = this.confirm_email
      if (typeof email === 'undefined' || email.length < 3) {
        return false
      }

      const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return regex.test(email)
    },
    isValidCode () {
      const code = this.verify_code
      return code.length > 0 && code.match(/^(\d\s*){6}$/g)
    }
  },
  methods: {
    verifyCode () {
      this.sending = true
      this.resetSmsFailedErr()
      this.verify_code_error = ''
      const payload = {
        token: this.mountedUserToken,
        verify_code: this.verify_code,
      }
      axios.post('/consumer/phone/confirm-verified-email-code', payload)
        .then(() => {
          this.sending = false
          this.showUpdatePhoneSuccessMessage = true
        })
        .catch((error) => {
          this.sending = false

          if ('errorKey' in error.response.data && error.response.data.errorKey === 'sms-send-failed') {
            this.populateSmsFailedErr(error.response.data.traceCode)
            this.isCodeSendForm = false
            this.isCodeVerifyForm = false
          } else if ('errors' in error.response.data && 'verify_code' in error.response.data.errors) {
            this.verify_code_error = error.response.data.errors.verify_code[0]
          }
        })
    },
    sendCode () {
      this.isCodeSendForm = true
      this.sending = true
      this.confirm_email_error = ''
      const payload = {
        token: this.mountedUserToken,
        confirm_email: this.confirm_email
      }
      axios.post('/consumer/phone/confirm-verified-email', payload)
        .then((data) => {
          this.sending = false
          this.isCodeVerifyForm = true
          this.isCodeSendForm = false
          this.form.errors.clear()
        })
        .catch((error) => {
          this.sending = false
          if ('errors' in error.response.data && 'confirm_email' in error.response.data.errors) {
            this.confirm_email_error = error.response.data.errors.confirm_email[0]
          }
        })
    },
    reEnterMobile () {
      this.$router.replace({
        path: this.$route.path,
        query: {t: Date.now()}
      })
    },
    verifyToken () {
      const resetToken = new ApiResource({})
      return resetToken.send(`/consumer/phone/verify/${this.token}`, {}, 'get')
        .then(() => this.mountedUserToken = this.token)
        .catch(() => {
          window.location.href = '/404'
        })
    },
    submitRegister () {
      this.form.errors.clear(null)
      this.$refs.recaptcha.execute()
    },
    submitOTP () {
      this.otp_form.errors.clear(null)
      this.$refs.recaptcha_otp.execute()
    },
    /**
     * Reset recaptcha when expired
     *
     * @returns {void}
     */
    onCaptchaExpiredOtp () {
      this.$refs.recaptcha_otp.reset()
    },
    /**
     * Handle when recaptcha passes
     *
     * @returns {void}
     */
    onCaptchaVerifiedOtp (recaptchaToken) {
      const self = this
      self.sending = true
      self.$refs.recaptcha_otp.reset()
      self.otp_form.recaptchaToken = recaptchaToken
      self.otp_form.send('/consumer/verify/otp')
        .then(() => {
          self.sending = false
          localStorage.setItem('auth_token', self.otp_form.token)
          localStorage.setItem('profile_id', self.otp_form.profile_id)
          localStorage.setItem('mobile', self.otp_form.mobile)
          localStorage.setItem('displayName', self.otp_form.displayName)
          localStorage.setItem('avatar', self.otp_form.avatar)
          delete window.auth
          this.$router.push({
            path: '/',
            query: {notification: 'Your account has been verified. You are now logged in'}
          })
        })
        .catch((errors) => {
          console.log('errors', errors)
          self.sending = false
          if ('errors' in errors) {
            Object.assign(self.otp_form.errors, errors)
          } else {
            console.log('errors from otp verify', errors.error)
            flash('There was an error verifying your OTP. Please contact admin@hellopeter.com', 'is-danger')
            // flash(errors.error, 'is-danger')
          }
        })
    },
    /**
     * Reset recaptcha when expired
     *
     * @returns {void}
     */
    onCaptchaExpired () {
      this.$refs.recaptcha.reset()
    },
    /**
     * Handle when recaptcha passes
     *
     * @returns {void}
     */
    onCaptchaVerified (recaptchaToken) {
      const self = this
      this.resetSmsFailedErr()
      self.sending = true
      self.$refs.recaptcha.reset()
      self.form.recaptchaToken = recaptchaToken
      self.form.token = this.token
      self.form.send('/consumer/phone/update')
        .then(() => {
          self.sending = false
          self.showUpdatePhoneSuccessMessage = true
          self.registerSuccessMessage = self.form.message
        })
        .catch((errors) => {
            console.log('onCaptchaVerified, errors', errors)
            self.sending = false

            if ('errors' in errors) {
              Object.assign(self.form.errors, errors)
            } else if ('errorKey' in errors && errors.errorKey === 'sms-send-failed') {
              this.populateSmsFailedErr(errors.traceCode)
            } else {
              flash(errors.error, 'is-danger')
            }
          }
        )
    }
  }
}
</script>
<style lang="scss" scoped>
#verifyPhonePage .control {
  margin-top: 10px;
  margin-bottom: 15px;
}

#verifyPhonePage #loginButton {
  margin-top: 30px;
}

.disclaimer {
  color: #58595B;
  margin-top: 1rem;
}

.social-email-require {
  background-color: #e8441f;
  color: #ffffff;
  font-size: 0.9rem;
  padding: 10px !important;
  margin-bottom: 20px;
}

.help {
  margin-top: -10px;
}

.register-success-message-box {
  padding: 10px !important;
  background-color: #0fa8e3;
  color: #ffffff;
  font-size: 0.9rem;
}

.captchaBox {
  padding: 6px 0 0;
}

.lh {
  line-height: 1.5rem;
}

.mt-5 {
  margin-top: 10px !important;
}

.mt-10 {
  margin-top: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/auth/VerifyPhone.vue